/** 活动类型 */
export var ActType;
(function (ActType) {
    /** 无门槛派发活动 */
    ActType["distribution"] = "distribution";
    /** 连锁券派发活动 */
    ActType["chain"] = "chain";
    /** 印花/资格兑换活动 */
    ActType["stampQualLimit"] = "stampQualLimit";
})(ActType || (ActType = {}));
/** 活动状态 */
export var ActState;
(function (ActState) {
    /** 未开始 */
    ActState[ActState["noStart"] = 0] = "noStart";
    /** 进行中 */
    ActState[ActState["ing"] = 1] = "ing";
    /** 已结束 */
    ActState[ActState["end"] = 2] = "end";
})(ActState || (ActState = {}));
/** 用户参与活动状态 */
export var UserActState;
(function (UserActState) {
    /** 没有资格 */
    UserActState[UserActState["noQual"] = 0] = "noQual";
    /** 未参与 */
    UserActState[UserActState["noJoin"] = 1] = "noJoin";
    /** 参与中 */
    UserActState[UserActState["joining"] = 2] = "joining";
    /** 已参与 */
    UserActState[UserActState["joined"] = 3] = "joined";
})(UserActState || (UserActState = {}));
/** 券和活动对应关系 */
export var CouponActRelation;
(function (CouponActRelation) {
    /** 一个券对应一个活动 */
    CouponActRelation["oneForOne"] = "oneForOne";
    /** 一个券对应多个活动 */
    CouponActRelation["oneForMore"] = "oneForMore";
})(CouponActRelation || (CouponActRelation = {}));
